import { useState } from 'react'
import { LayoutGrid, Search } from 'lucide-react'
import BookingCatalog from '@/components/Bookings/BookingCatalog'
import BookingFilterPage from '@/pages/BookingFilterPage'

export default function BookingUnifiedPage() {
    const [activeTab, setActiveTab] = useState<'catalog' | 'search'>('catalog')

    return (
        <div className="max-w-6xl w-full mx-auto p-6 space-y-8 page-enter">
            {/* Header Section */}
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 pb-6 border-b-2 border-[#001c28]/5">
                <div className="space-y-2">
                    <h1 className="text-3xl font-black text-[#001c28] tracking-tighter uppercase italic leading-[0.9]">Reservar Espaço</h1>
                    <p className="font-bold text-[#001c28]/80 text-sm max-w-2xl">
                        Encontre o espaço ideal para você.
                    </p>
                </div>

                <div className="flex bg-white p-1.5 rounded-xl border border-[#001c28]/10 shadow-sm">
                    <button
                        onClick={() => setActiveTab('catalog')}
                        className={`flex items-center gap-2 px-5 py-2.5 rounded-lg text-[10px] font-black transition-all uppercase tracking-widest ${activeTab === 'catalog'
                            ? 'bg-[#001c28] text-[#d4a94d] shadow-lg shadow-[#001c28]/20'
                            : 'text-[#001c28]/40 hover:text-[#001c28] hover:bg-[#001c28]/5'
                            }`}
                    >
                        <LayoutGrid className="w-3.5 h-3.5" />
                        Catálogo
                    </button>
                    <button
                        onClick={() => setActiveTab('search')}
                        className={`flex items-center gap-2 px-5 py-2.5 rounded-lg text-[10px] font-black transition-all uppercase tracking-widest ${activeTab === 'search'
                            ? 'bg-[#001c28] text-[#d4a94d] shadow-lg shadow-[#001c28]/20'
                            : 'text-[#001c28]/40 hover:text-[#001c28] hover:bg-[#001c28]/5'
                            }`}
                    >
                        <Search className="w-3.5 h-3.5" />
                        Busca Avançada
                    </button>
                </div>
            </div>

            <div className="mt-2">
                {activeTab === 'catalog' ? (
                    <div className="animate-in fade-in slide-in-from-left-4 duration-500">
                        <BookingCatalog />
                    </div>
                ) : (
                    <div className="animate-in fade-in slide-in-from-right-4 duration-500">
                        <BookingFilterPage />
                    </div>
                )}
            </div>
        </div>
    )
}
